import { Component, OnInit, Inject } from '@angular/core';
import { AnnounceInfo } from '../model/announce.model';
import { LookupInfo } from '../model/lookup.model';
import { RoleInfo } from '../model/role.model';
import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { CompanyInfo } from '../model/company.model';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { Observable } from 'rxjs';
import { GlobalService } from '../service/global.service';
import { PositionLevelInfo } from '../model/PositionManagementInfo.model';
import { T } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-announce-management',
  templateUrl: './announce-management.component.html',
  styleUrls: ['./announce-management.component.css']
})
export class AnnounceManagementComponent implements OnInit {

  AnnounceOnPromise: Promise<AnnounceInfo[]>
  announceList: AnnounceInfo[] = [];

  LookupPromise: Promise<LookupInfo[]>

  startDate = new FormControl(new Date());
  endDate = new FormControl(new Date());

  isSearchSubmitted: boolean = false;
  txtSearchFlagActive: string
  txtSearchAnnTitle: string
  txtSearchCompany: string

  txtAnnounceCode: string
  txtExEmpCode: string
  txtPathPhoto: string
  txtAnnoouncementTitle: string
  txtAnnouncementDetailTH: string
  txtAnnouncementDetailEN: string
  txtDepartment: string
  txtFlagActive: string
  hidAnnounceId: number
  announcementStartDate: string;
  announcementEndDate: string;
  //txtFilesAttached: string;

  isOnUpdate: boolean;
  isSubmitted: any;


  //Pagination variable
  public currentPageNumber: number
  public AnnounceTotal: any
  public totalPages: number
  public environment: number

  element: HTMLElement;
  public hidcouchk: string;
  baseurl: string;
  public empcodeinit: string
  _ForK2: string;
  _EmpCode: string;

  getTokenUrl: string;

  //Modal
  titlemodal: string;
  detailmodal: string;

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private activatedRoute: ActivatedRoute, private TokenService: TokenService, private GlobalService: GlobalService) {
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._EmpCode = this.activatedRoute.snapshot.params.EmpCode;
    GlobalService.CheckPagingAccessRights();
  }


  async ngOnInit() {

    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    
    $(document).ready(function () {
      $('#InsertSectionAnnounce').css('display', 'none');
    });
    
    this.currentPageNumber = 1;
    this.environment = environment.PageSize;
    this.LoadAnnounce()
    this.announcementStartDate = ""
    this.announcementEndDate = ""

    this.LoadAnnounce();
  }
  ///////////////////////////////////////Events////////////////////////////////////////////
  btnClick_showAnnounceList() {
    this.isSearchSubmitted = true;
    this.LoadAnnounce()
  }

  btnClick_onInsertAnnounce() {
    this.announcementStartDate = ""
    this.announcementEndDate = ""
    this.clearInsertSection();
    $('#InsertSectionAnnounce').css('display', 'block');
    this.isOnUpdate = false
  }

  btnClick_onUpdateAnnounce(id) {
    $('#InsertSectionAnnounce').css('display', 'block');
    document.getElementById("AddEditAnnouncements").scrollIntoView();
    this.isOnUpdate = true
  

    let index = this.announceList.findIndex(x => x.AnnouncementId == id);
    this.hidAnnounceId = this.announceList[index].AnnouncementId

    this.txtAnnounceCode = this.announceList[index].AnnoouncementTitle
    this.announcementStartDate = this.announceList[index].AnnouncementStartDate != null ? new Date(this.announceList[index].AnnouncementStartDate).toLocaleDateString('en-CA') : null
    this.announcementEndDate = this.announceList[index].AnnouncementEndDate != null ? new Date(this.announceList[index].AnnouncementEndDate).toLocaleDateString('en-CA') : null
    this.txtAnnoouncementTitle = this.announceList[index].AnnoouncementTitle
    //this.txtAnnouncementDetailTH = this.announceList[index].AnnouncementDetailTH
    //this.txtAnnouncementDetailEN = this.announceList[index].AnnouncementDetailEN
    //this.txtDepartment = this.announceList[index].Department
    //this.txtFlagActive = this.announceList[index].FlagActive
    
    //this.txtPathPhoto = this.announceList[index].PathPhoto;
    //this.txtFilesAttached = this.announceList[index].FilesAttached;
  }

  async btnClick_deleteAnnounce(id, bypassDialog: boolean = false) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      let strjsonCusInfo = "{AnnouncementId: " + id + "}";

      if (bypassDialog || confirm("Are you sure you want to delete this announcement?")) {
        this.isSubmitted = this.httpClient.post<AnnounceInfo[]>(this.baseurl + "Announcement/DeleteAnnouncement", strjsonCusInfo, httpOptions)
          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'Announcement information has been deleted successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadAnnounce()
            }
          )
      }
    }

  }

  async btnClick_submitInsertAnnounce() {
    
    $('#InsertSectionAnnounce').css('display', 'block');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (!this.announceDateValidation()) return;

      //this.txtExEmpCode = this.AnnounceTotal + 1;
      if (this.txtAnnoouncementTitle == null || this.txtAnnoouncementTitle == '') {

        let objData = {};

        objData["AnnouncementStartDate"] = this.announcementStartDate;
        objData["AnnoouncementTitle"] = this.txtAnnoouncementTitle;
        //objData["AnnouncementDetailTH"] = this.txtAnnouncementDetailTH;
        //objData["AnnouncementDetailEN"] = this.AnnouncementDetailEN;
        objData["AnnouncementEndDate"] = this.announcementEndDate;
        //objData["FilesAttached"] = this.txtFilesAttached;
        objData["CreateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<AnnounceInfo[]>(this.baseurl + "Announcement/InsertAnnouncement", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionAnnounce').css('display', 'none');
              //this.AuthorizeUser(this.ddlCompany + "0" + this.txtExEmpCode);

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been created successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              this.LoadAnnounce()
            }
          )
      }
      else {

        let objData = {};
        objData["AnnouncementStartDate"] = this.announcementStartDate;
        objData["AnnoouncementTitle"] = this.txtAnnoouncementTitle;
        //objData["AnnouncementDetailTH"] = this.txtAnnouncementDetailTH;
        //objData["AnnouncementDetailEN"] = this.AnnouncementDetailEN;
        objData["AnnouncementEndDate"] = this.announcementEndDate;
        //objData["FilesAttached"] = this.txtFilesAttached;
        objData["CreateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        objData["FlagDelete"] = "N";

        
        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<AnnounceInfo[]>(this.baseurl + "Announcement/InsertAnnouncement", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Insert fail")
          },
            () => {
              console.log("Insert = " + this.isSubmitted)
              this.clearInsertSection()
              
              $('#InsertSectionAnnounce').css('display', 'none');
              //this.AuthorizeUser(this.txtAnnounceCode);

              this.LoadAnnounce()
            }
          )
      }
    }

  }

  
  btnClick_submitUpdateAnnounce(id) {

    if (!this.announceDateValidation()) return;

    $('#ModalConfirmChanges').modal();
  }

  announceDateValidation(): boolean {
    var status = true;
    if (!this.announcementEndDate) {
      this.announcementEndDate = this.announcementStartDate;
    }
    if (this.announcementEndDate < this.announcementStartDate) {
      alert("วันสิ้นสุดไม่สามารถมาก่อนวันเริ่มได้ กรุณาตรวจสอบวันที่");
      status = false;
    }

    return status;
  }

  async confirmSaveChanges() {
    $('#ModalConfirmChanges').modal('hide');
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      
      $('#InsertSectionAnnounce').css('display', 'block');
      var id = this.hidAnnounceId
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      if (this.txtAnnounceCode == undefined || this.txtAnnounceCode == null || this.txtAnnounceCode == '') {
        alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      }
      else {

        let objData = {};
        objData["AnnouncementId"] = id;

        objData["AnnouncementStartDate"] = this.announcementStartDate;
        objData["AnnoouncementTitle"] = this.txtAnnoouncementTitle;
        //objData["AnnouncementDetailTH"] = this.txtAnnouncementDetailTH;
        //objData["AnnouncementDetailEN"] = this.AnnouncementDetailEN;
        objData["AnnouncementEndDate"] = this.announcementEndDate;
        //objData["FilesAttached"] = this.txtFilesAttached;
        objData["UpdateBy"] = this.checkUndefinedString(localStorage.getItem("EmpCode"));
        objData["FlagDelete"] = "N";

        let strjson = JSON.stringify(objData);

        this.isSubmitted = this.httpClient.post<AnnounceInfo[]>(this.baseurl + "Announcement/UpdateAnnouncement", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
          },
            () => {
              console.log("Update = " + this.isSubmitted)
              this.clearInsertSection()
              $('#InsertSectionAnnounce').css('display', 'none');

              //Inform user
              this.titlemodal = '';
              this.detailmodal = 'User information has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();

              //Load new data
              this.LoadAnnounce()
            }
          )
      }
    }
  }

  chkallclick() {
    for (var i = 0; i <= 100; i++) {
      this.element = document.getElementById('chk' + i) as HTMLElement;
      this.element.click();
    }
  }

  async btnClick_onDeleteAnnounce() {
    let num = parseInt(this.hidcouchk);

    let checkednum = (() => {
      let x = 0;
      for (var i = 0; i < num; i++) {
        var element = <HTMLInputElement>document.getElementById('chk' + i);
        if (element.checked) x++;
      }
      return x;
    })();

    if (confirm("Are you sure you want to delete " + checkednum +" announcements?")) {
      for (var i = 0; i < num; i++) {
        var element = <HTMLInputElement>document.getElementById('chk' + i);
        var isChecked = element.checked;

        var element2 = <HTMLInputElement>document.getElementById('AnnouncementId' + i);

        if (isChecked) {
          await this.btnClick_deleteAnnounce(parseInt(element2.value), true);
        }
      }
      this.LoadAnnounce();
    }
  }

  btnClick_AuthorizeUser(EmpCode) {
    this.AuthorizeUser(EmpCode);
  }
  ///////////////////////////////////////Functions/////////////////////////////////////////

  LoadAnnounce() {
    this.LoadAnnounceList()
      .then(
        data => {
          this.announceList = data
          this.hidcouchk = this.announceList.length.toString();
        }
      )
      .then(() => {
        this.CountAnnounceList()
      })
  }

  async LoadAnnounceList(): Promise<AnnounceInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;
      
      var objectjson = {};
      objectjson['AnnoouncementTitle'] = this.checkUndefinedString(this.txtSearchAnnTitle);
      objectjson['FlagActive'] = this.checkUndefinedString(this.txtSearchFlagActive);
      objectjson['rowFetch'] = environment.PageSize;
      objectjson['rowOFFSet'] = offset;
      objectjson['FlagDelete'] = "N";

      let strjson = JSON.stringify(objectjson);

      console.log(strjson)

      this.AnnounceOnPromise = this.httpClient
        .post<AnnounceInfo[]>(this.baseurl + "Announcement/GetAnnouncement",
          strjson, httpOptions)
        .toPromise()

      return this.AnnounceOnPromise;
    }
  }

  async CountAnnounceList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSize;


      let strjson = "{\"AnnoouncementTitle\": \"" + this.checkUndefinedString(this.txtSearchAnnTitle) + "\", " +
        "\"FlagActive\": \"" + this.checkUndefinedString(this.txtSearchFlagActive) + "\", " +
        "\"FlagDelete\": \"N\"" +
        "}";


      this.httpClient
        .post<AnnounceInfo[]>(this.baseurl + "Announcement/GetCountAnnouncement",
          strjson, httpOptions)
        .toPromise().then(data => {
          this.AnnounceTotal = data
        })
        .then(() => {
          if (this.AnnounceTotal == 0) {
            this.currentPageNumber = 1;
          }
          this.totalPages = Math.ceil(this.AnnounceTotal / environment.PageSize)
        })
    }
  }


  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }

  clearInsertSection() {
    this.hidAnnounceId = null
    

    this.txtAnnounceCode = "";
    this.txtAnnoouncementTitle = ""
    this.txtAnnouncementDetailTH = ""
    this.txtAnnouncementDetailEN = ""
    this.txtDepartment = "";
    this.txtFlagActive = "";
    this.announcementStartDate = null;
    this.announcementEndDate = null;
    this.txtPathPhoto = "";
    //this.txtFilesAttached = "";

  }

  clearSearchSection() {

    this.txtSearchFlagActive = ""
    this.txtSearchAnnTitle = ""
    this.txtSearchCompany = ""
    this.isSearchSubmitted = false;
    this.LoadAnnounce();
  }

  btnClick_cancel() {
    this.clearInsertSection();
    $('#InsertSectionAnnounce').css('display', 'none');
  }

  //For Pagination
  LoadListPagination(traget) {
    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
  }

  OnLoadListFinished(traget = null) {

    if (traget != null) { // check call function from change page or onloadfrist
      this.LoadListPagination(traget);
      this.LoadAnnounce();
    }

  }

  AuthorizeUser(txtAnnounceCode) {
    //Open new tab to do OAuth2
    this.getTokenUrl = this.TokenService.GetAccessTokenUrl(txtAnnounceCode);
    
    window.open(this.getTokenUrl, "_blank");

  }
}
